<template>
  <div class="register-container">
    <change-email-successfully v-if="isSuccess" :email="email"></change-email-successfully>
    <change-email-fail v-else-if="isSuccess === false"></change-email-fail>
  </div>
</template>
<script>
import SettingService from '@/services/settingservice'
import ChangeEmailFail from '@/view/setting/ChangeEmailFail'
import ChangeEmailSuccessfully from '@/view/setting/ChangeEmailSuccessfully'

export default {
  data () {
    return {
      token: null,
      isSuccess: null,
      email: null,
      err: null
    }
  },

  components: {
    ChangeEmailFail,
    ChangeEmailSuccessfully
  },

  created () {
    this.token = this.$route.query.token
    this.initPage()
  },

  methods: {
    async initPage () {
      const loader = this.$loading.show()
      await this.confirmChangeMail()
      loader.hide()
    },

    confirmChangeMail () {
      SettingService.confirmChangeMail(this.token)
        .then((response) => {
          this.isSuccess = true
          this.email = response.email
        })
        .catch(() => {
          this.isSuccess = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/setting/ConfirmChangeEmail.vue